import { store } from "redux/store";

export const checkIsDraftComposition = (compositionListParam = null) => {
  const compositionList =
    compositionListParam ||
    store?.getState()?.encounterObj?.encounter?.compositionList;

  // Accepts compositionList and returns the element with title "Draft Transcript" or false if not found
  if (!Array.isArray(compositionList) || !compositionList?.length) {
    console.warn(
      "checkIsDraftComposition: compositionList is not a valid array:",
      compositionList,
    );
    return false;
  }

  const draftComposition = compositionList?.find((item) => {
    return item?.resource?.title === "Draft Transcript";
  });

  return draftComposition || false; // Returns the matching element or false if not found
};

export const checkIsDraftCompositionAndInProgress = (
  compositionListParam = null,
) => {
  const compositionList =
    compositionListParam ||
    store?.getState()?.encounterObj?.encounter?.compositionList;

  // Accepts compositionList and returns the element with title "Draft Transcript" or false if not found
  if (!Array.isArray(compositionList) || !compositionList?.length) {
    console.warn(
      "checkIsDraftCompositionAndInProgress: compositionList is not a valid array:",
      compositionList,
    );
    return false;
  }

  const draftComposition = compositionList?.find((item) => {
    return (
      item?.resource?.title === "Draft Transcript" &&
      item?.resource?.section?.[4]?.title &&
      /\d/.test(item?.resource?.section?.[4]?.title)
    );
  });

  return draftComposition || false; // Returns the matching element or false if not found
};

export const formatComposition = (composition) => {
  //Accepts a composition and extracts raw conversation in an array
  try {
    if (!composition) return [];
    const rawTranscriptStringified =
      composition?.resource?.section?.[3]?.title?.replace(
        "rawTranscript: ",
        "",
      );
    if (rawTranscriptStringified.length < 3) return [];
    const rawTranscriptObjectList = JSON.parse(rawTranscriptStringified);
    if (!Array.isArray(rawTranscriptObjectList)) {
      console.warn(
        "formatComposition: parsed transcript is not an array:",
        rawTranscriptObjectList,
      );
      return [];
    }
    return rawTranscriptObjectList?.map((item) => {
      return item?.text;
    });
  } catch (error) {
    console.log("Error While parsing raw transcript", error.message);
    return [];
  }
};

/**
 * Checks if an encounter has only one Draft conversation with no transcript duration i.e New Encounter with new conversationID
 * @param {array} compositionListParam - Optional accessed directly from store
 * @returns {boolean} - True if current encounter is an new encounter
 */
export const IsNewEncounterWithDraft = (compositionListParam = null) => {
  const compositionList =
    compositionListParam ||
    store?.getState()?.encounterObj?.encounter?.compositionList;

  const uniqueIds = new Set(
    compositionList?.map(({ resource }) => resource?.id),
  );

  if (uniqueIds.size === 1) {
    const item = compositionList?.[0];
    return (
      item?.resource?.title === "Draft Transcript" &&
      item?.resource?.section?.[4]?.title &&
      !/\d/.test(item?.resource?.section?.[4]?.title)
    );
  }
  return false;
};
